class FaqGroups extends HTMLElement {
  constructor() {
    super();
    this.pills = Array.from(this.querySelectorAll('[data-faq-group]'));
    this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.select(pill.dataset.faqGroup));
    });
  }

  select(groupId) {
    this.pills.forEach((pill) => {
      const active = pill.dataset.faqGroup === groupId;
      pill.classList.toggle('faq-groups__pill--active', active);
      pill.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const active = panel.dataset.faqPanel === groupId;
      panel.classList.toggle('faq-groups__panel--active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

customElements.define('faq-groups', FaqGroups);
